import { useDashboardApiClient } from '@/api/dashboard/useDashboardApiClient'
import type { Workspace, WorkspaceOverview, TemplateSummaryDto, WorkspaceTemplateSetupDto } from './types'
import { useBuilderApiClient } from '@/api/builder/useBuilderApiClient'

const ENDPOINTS = {
    WORKSPACES: '/workspaces/',
    WORKSPACE_ID: '/workspaces/:workspaceId',
    WORKSPACE_TEMPLATES: '/workspace-templates',
    WORKSPACE_TEMPLATE_SETUP: '/external-dashboard/workspaces/:workspaceId/template-setup',
    WORKSPACE_TEMPLATE_SETUP_RESTART: '/external-dashboard/workspaces/:workspaceId/template-setup/restart',
}

export const getWorkspaces = () => {
    return useDashboardApiClient<WorkspaceOverview[]>({
        url: ENDPOINTS.WORKSPACES,
    })
}

export type WorkspaceBodyData = {
    name: string
    description?: string
    tags?: { name: string, color: string }[]
    templateId?: string
}

type WorkspaceParams = {
    workspaceId: string
}

export const getWorkspace = (urlParams: WorkspaceParams) => {
    return useDashboardApiClient<Workspace>({
        url: ENDPOINTS.WORKSPACE_ID,
        urlParams,
        method: 'GET',
    })
}

export const postWorkspace = (data: WorkspaceBodyData) => {
    return useDashboardApiClient<WorkspaceOverview>({
        url: ENDPOINTS.WORKSPACES,
        method: 'POST',
        data,
    })
}

export const deleteWorkspace = (params: WorkspaceParams) => {
    return useDashboardApiClient({
        url: ENDPOINTS.WORKSPACE_ID,
        urlParams: {
            workspaceId: params.workspaceId,
        },
        method: 'DELETE',
    })
}

export const updateWorkspace = (params: WorkspaceParams, data?: WorkspaceBodyData) => {
    return useDashboardApiClient<WorkspaceOverview>({
        url: ENDPOINTS.WORKSPACE_ID,
        urlParams: {
            workspaceId: params.workspaceId,
        },
        method: 'PATCH',
        data,
    })
}

export const getWorkspaceTemplates = () => {
    return useDashboardApiClient<TemplateSummaryDto[]>({
        url: ENDPOINTS.WORKSPACE_TEMPLATES,
    })
}

export const getWorkspaceTemplateSetup = (urlParams: WorkspaceParams) => {
    return useBuilderApiClient<WorkspaceTemplateSetupDto>({
        url: ENDPOINTS.WORKSPACE_TEMPLATE_SETUP,
        urlParams,
    })
}

export const restartWorkspaceTemplateSetup = (urlParams: WorkspaceParams) => {
    return useBuilderApiClient<WorkspaceTemplateSetupDto>({
        url: ENDPOINTS.WORKSPACE_TEMPLATE_SETUP_RESTART,
        urlParams,
        method: 'POST',
    })
}

